import * as fc from 'utils/fieldConstants';
import {
  GeoLocationComparator,
  IsWithinComparator,
  StringComparator,
} from 'modules/queryBuilder/types';

export const disallowedIsOneOfValueFields = [
  fc.MESSAGE_ID,
  fc.CONTENT_ID,
  fc.MESSAGE_TYPE,
  fc.MESSAGE_CHANNEL,
  fc.UNSUBSCRIBED_CHANNEL,
  fc.UNSUBSCRIBED_CHANNELS,
  fc.UNSUBSCRIBED_MESSAGE_TYPE,
  fc.UNSUBSCRIBED_MESSAGE_TYPES,
  fc.SUBSCRIBED_MESSAGE_TYPES,
  fc.HREF_INDEX,
];

export const campaignFields = [fc.CAMPAIGN, fc.RECURRING_CAMPAIGN, fc.EMAIL_CAMPAIGN];

export const CatalogStringComparators = {
  EQUALS: StringComparator.EQUALS,
  DOES_NOT_EQUAL: StringComparator.DOES_NOT_EQUAL,
  IS_SET: StringComparator.IS_SET,
};

export const CatalogGeoLocationComparators = {
  ...GeoLocationComparator,
  IS_WITHIN: IsWithinComparator.IS_WITHIN,
};
